import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Route, IndexRoute, Link } from 'react-router'
import styles from './IndexPage.scss'
import appStyles from '../App/appStyles.scss'
import { AdminPageContainer } from '../AdminPage'
import { ShowcaseContainer as RolloutShowcase } from '../RolloutContest/Showcase'
import { VoteAdminContainer } from '../RolloutContest/VoteAdmin'
import { rrMessages } from '../intlMessages'
import { ReportListContainer } from './ReportList'
import { DraftListContainer } from './DraftList'
import { Button } from 'common/Button'
import { Gleam } from 'common/Gleam'
import { TwoTierNav, NavbarLink, NavbarIndexLink } from 'common/TwoTierNav'
import { GlobalFooter } from 'common/GlobalFooter'
import { Msg, useFormatMessage, featureNames, commonMessages } from 'lib/localization'
import cx from 'classnames'
import Helmet from 'react-helmet'
import { FormattedMessage as T } from 'react-intl'

export const rrSubnav = ({ currentUser, draftCount }) => <Fragment>
  <div>
    <NavbarIndexLink to='/ride_reports'><T id='IndexPage.featuredReports' defaultMessage='Featured Reports' /></NavbarIndexLink>
    <NavbarLink to='/ride_reports/rollout2017'><T id='IndexPage.rolloutWinners' defaultMessage='Rollout Contest Winners' /></NavbarLink>
    <NavbarLink to='/ride_reports/recent'><Msg m={rrMessages.recent} /></NavbarLink>
    {currentUser.id && <NavbarLink to='/ride_reports/friends'><T id='IndexPage.fromFriends' defaultMessage='From Friends' /></NavbarLink>}
    {currentUser.id && <NavbarLink to='/ride_reports/following'><Msg m={rrMessages.following} /></NavbarLink>}
  </div>
  <div>
    {currentUser.id && <NavbarLink to={`/ride_reports/user/${currentUser.id}/`}><Msg m={rrMessages.yourReports} /></NavbarLink>}
    {currentUser.accountLevel === 11 && <NavbarLink to='/ride_reports/admin'>Admin</NavbarLink>}
    {currentUser.id && <NavbarLink to='/ride_reports/drafts'>
      <Msg m={rrMessages.drafts} /> {draftCount > 0 && <Gleam>{draftCount}</Gleam>}
    </NavbarLink>}
    {currentUser.id && <Link to='/ride_reports/new' className={styles.bold}><Button type='success'>+ <Msg m={rrMessages.newReport} /></Button></Link>}
  </div>
</Fragment>

export const IndexPage = ({ children, currentUser, draftCount }) => (
  <div className={cx(appStyles.base, styles.wrapper)}>
    <TwoTierNav secondaryNav={rrSubnav({ currentUser, draftCount })} />
    <div className={styles.IndexPage}>
      {children}
    </div>
    <GlobalFooter className={styles.footer} />
  </div>
)

const Featured = () => {
  const fm = useFormatMessage()
  return <ReportListContainer endpoint='featured' title={fm(commonMessages.getInspired)}>
    <Helmet title={`${fm(featureNames.rideReports)} · ${fm(rrMessages.featured)}`} />
  </ReportListContainer>
}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  draftCount: state.editPage.draftList.size,
  rolloutParticipant: window.rwgps.config.rolloutParticipant
})

export const FeaturedContainer = connect(
  mapStateToProps,
  null
)(Featured)

export const IndexPageContainer = connect(
  mapStateToProps,
  null
)(IndexPage)

const Recent = () => {
  const fm = useFormatMessage()
  return <ReportListContainer endpoint='recent' title={<T id='IndexPage.latestReports' defaultMessage='Latest Reports' />}>
    <Helmet title={`${fm(featureNames.rideReports)} · ${fm(rrMessages.recent)}`} />
  </ReportListContainer>
}

const Friends = () => {
  const fm = useFormatMessage()
  return <ReportListContainer endpoint='friends' title={<T id='IndexPage.friendsReports' defaultMessage="Friends' Reports" />}>
    <Helmet title={`${fm(featureNames.rideReports)} · ${fm(featureNames.friends)}`} />
  </ReportListContainer>
}

const Following = () => {
  const fm = useFormatMessage()
  return <ReportListContainer endpoint='following' title={<T id='IndexPage.fromFollow' defaultMessage='Reports from Users You Follow' />}>
    <Helmet title={`${fm(featureNames.rideReports)} · ${fm(rrMessages.following)}`} />
  </ReportListContainer>
}

const ContestEntries = () => {
  const fm = useFormatMessage()
  return <ReportListContainer endpoint='contest_entries' title={<T id='IndexPage.latestEntries' defaultMessage='Latest Contest Entries' />}>
    <Helmet title={`${fm(featureNames.rideReports)} · ${fm(rrMessages.contestEntries)}`} />
  </ReportListContainer>
}

const UserReports = ({ params: { userId } }) => (<ReportListContainer endpoint={`/user/${userId}`} />) // not applying a title here because we don't know the user's name. This component is due for a refactor.

const SecretFinalistCandidatePage = () => (
  <ReportListContainer endpoint='inquisitive_marauding_wombat' title='Finalist Candidate List'>
    <p>This is our list of the cream of the crop from all 8 weeks that the contest has been running</p>
    <p>Please <strong>do not</strong> share this URL, it's super-secret for your eyes only!</p>
  </ReportListContainer>)

const Drafts = (props) => (<DraftListContainer {...props} />)

export const IndexRoutes = (
  <Route component={IndexPageContainer}>
    <IndexRoute component={FeaturedContainer} />
    <Route path='recent' component={Recent} />
    <Route path='friends' component={Friends} />
    <Route path='following' component={Following} />
    <Route path='contest_entries' component={ContestEntries} />
    <Route path='drafts' component={Drafts} />
    <Route path='user/:userId' component={UserReports} />
    <Route path='admin' component={AdminPageContainer} />
    <Route path='rollout2017' component={RolloutShowcase} />
    <Route path='vote_admin' component={VoteAdminContainer} />
    <Route path='inquisitive_marauding_wombat' component={SecretFinalistCandidatePage} />
  </Route>
)
